import { generateActions } from "utils/generateActions";

export const GET_TABLE_USERS = generateActions("GET_TABLE_USERS");
export const UPLOAD_USERS = generateActions("UPLOAD_USERS");